const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const DeleteLicenses = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LICENSES_DELETE_REQUEST":
      return { loading: true, error: false, data: [] };
    case "LICENSES_DELETE_ERROR":
      return { loading: false, error: true, data: [] };
    case "LICENSES_DELETE_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "LICENSES_DELETE_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default DeleteLicenses;
